export function getMobileStandalone(container, mobile, fallbackPage) {
  if (!mobile?.standalone) return null;
  const pageId = String(mobile.page ?? fallbackPage);
  const page = Array.from(container.querySelectorAll('.pages-inner > .page'))
    .find(element => element.dataset.id === pageId);
  if (!page) return null;
  let section = Array.from(container.querySelectorAll('.quote-mobile-section'))
    .find(element => element.dataset.afterPage === pageId);
  if (!section) {
    section = document.createElement('section');
    section.className = 'quote-mobile-section';
    section.dataset.afterPage = pageId;
    page.after(section);
  }
  if (mobile.standaloneHeight) {
    section.dataset.fixedHeight = 'true';
    section.style.height = mobile.standaloneHeight;
  }
  return section;
}